// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using
// the `rails generate channel` command.
// TODO: Look for a replace for ActionCable to create Websocket channels
import { createConsumer } from '@rails/actioncable';

export default createConsumer();
